<template>
    <Head :title="$t('manage-attendance')"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <Toolbar class="mb-4">
                    <template v-slot:start>
                            <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-3">
                                    <AutoComplete
                                        forceSelection
                                        placeholder="Nama Karyawan"
                                        id="dd"
                                        :dropdown="true"
                                        v-model="selectedEmployee"
                                        :suggestions="autoFilteredValue.employee"
                                        @complete="searchEmployee($event)"
                                        field="name"
                                    />
                                </div>
                                <div class="field col-12 md:col-3">
                                    <AutoComplete
                                        forceSelection
                                        placeholder="Unit Penempatan"
                                        id="up"
                                        :dropdown="true"
                                        v-model="selectedUnit"
                                        :suggestions="autoFilteredValue.unit"
                                        @complete="searchUnit($event)"
                                        field="name"
                                    />
                                </div>
                                <div class="field col-12 md:col-3">
                                    <Calendar v-model="startDate" :showIcon="true" dateFormat="dd-mm-yy" placeholder="Dari Tanggal">
                                    </Calendar>
                                </div>
                                <div class="field col-12 md:col-3">
                                    <Calendar v-model="endDate" :showIcon="true" dateFormat="dd-mm-yy" :showButtonBar="true" placeholder="Sampai Tanggal">
                                    </Calendar>
                                </div>
                                <div class="field col-12 md:col-3">
                                    <Button
                                            label="Cari"
                                            icon="pi pi-zoom"
                                            class="p-button-primary ml-2"
                                            @click="changeFilters"
                                        />
                                </div>
                            </div>
                    </template>
                    <template v-slot:end>
                        <Button
                                label="Export Reports"
                                icon="pi pi-print"
                                class="p-button-success"
                                :disabled="exportLoading.pdf.withPhoto"
                                @click="exportDetailToPdf"
                            />
                        <Button
                                label="Export Reports Without Photo"
                                icon="pi pi-print"
                                class="ml-3 p-button-success"
                                :disabled="exportLoading.pdf.withoutPhoto"
                                @click="exportWithoutPhotoToPdf"
                            />
                        <Button
                                label="Export Reports Excel"
                                icon="pi pi-print"
                                class="ml-3 p-button-success"
                                :disabled="exportLoading.excel.withPhoto"
                                @click="exportExcel"
                            />
                        <Button
                                label="Export Reports Without Photo Excel"
                                icon="pi pi-print"
                                class="ml-3 p-button-success"
                                :disabled="exportLoading.excel.withoutPhoto"
                                @click="exportWithoutPhotoExcel"
                            />
                    </template>
                </Toolbar>
                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    :selectAll="selectAll"
                    @select-all-change="onSelectAllChange"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Rekap Kehadiran</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="filters['global'].value"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                        headerStyle="width: 3rem"
                    ></Column>
                    <Column
                        field="tanggal"
                        header="Tanggal"
                        :sortable="true"
                        headerStyle="width:5%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Id</span>
                            {{ slotProps.data.tanggal }}
                        </template>
                    </Column>
                    <Column
                        field="employee_name"
                        header="Nama Karyawan"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Name</span>
                            {{ slotProps.data.employee_name }}
                        </template>
                    </Column>
                    <Column
                        field="placement"
                        :header="$t('placement')"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Name</span>
                            {{ slotProps.data.placement }}
                        </template>
                    </Column>
                    <Column
                        field="shift_type"
                        header="Tipe Shift"
                        headerStyle="width:5%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">shift_type</span>
                            {{ slotProps.data.shift_type }}
                        </template>
                    </Column>
                    <Column
                        field="shift_time_start"
                        header="Jam Masuk"
                        headerStyle="width:5%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">shift_type</span>
                            {{ slotProps.data.shift_time_start }}
                        </template>
                    </Column>
                    <Column
                        field="shift_time_end"
                        header="Jam Pulang"
                        headerStyle="width:5%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">shift_type</span>
                            {{ slotProps.data.shift_time_end }}
                        </template>
                    </Column>
                    <Column
                        field="clock_in"
                        header="Absen Masuk"
                        headerStyle="width:5%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">shift_type</span>
                            {{ slotProps.data.clock_in }}
                        </template>
                    </Column>
                    <Column
                        field="clock_out"
                        header="Absen Pulang"
                        headerStyle="width:5%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">shift_type</span>
                            {{ slotProps.data.clock_out }}
                        </template>
                    </Column>
                    <Column headerStyle="width:15%;min-width:10rem;">
                        <template #body="slotProps">
                            <Button
                                icon="pi pi-eye"
                                class="p-button-warning mt-2"
                                @click="showDetail(slotProps.data)"
                            />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <Dialog
            v-model:visible="modelDialog"
            :style="{ width: '450px' }"
            header="Detail Kehadiran"
            :modal="true"
        >
        <div class="flex flex-wrap w-full align-items-center justify-content-center">
            <div class="col-6 bg-gray-300">Tanggl</div>
            <div class="col-6">{{ modelDetail.shift_date }}</div>
            <div class="col-6 bg-gray-300">Penempatan</div>
            <div class="col-6">{{ modelDetail.placement}}</div>
            <div class="col-6 bg-gray-300">Absen Masuk</div>
            <div class="col-6">{{ modelDetail.clock_in }}</div>
            <div class="col-6 bg-gray-300">Absen Pulang</div>
            <div class="col-6">{{ modelDetail.clock_out }}</div>
            <div class="col-6 bg-gray-300">Foto Masuk</div>
            <div class="col-6">
                <Image :src="modelDetail.foto_jam_absen" alt="Image" width="250" preview />
            </div>
            <div class="col-6 bg-gray-300">Foto Pulang</div>
            <div class="col-6">
                <Image :src="modelDetail.foto_jam_pulang" alt="Image" width="250" preview />
            </div>
        </div>
        <template #footer>
            <Button
                label="Close"
                icon="pi pi-times"
                class="p-button-text"
                @click="modelDialog = false"
            />
        </template>
    </Dialog>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue3";
import axios from "axios";
import { FilterMatchMode } from "primevue/api";
import AutoComplete from "primevue/autocomplete";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import Checkbox from "primevue/checkbox";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import FileUpload from "primevue/fileupload";
import Image from "primevue/image";
import InputNumber from "primevue/inputnumber";
import InputText from "primevue/inputtext";
import Message from "primevue/message";
import Password from "primevue/password";
import RadioButton from "primevue/radiobutton";
import Toast from "primevue/toast";
import Toolbar from "primevue/toolbar";
import AppLayout from "../../../Layouts/AppLayout";
import DatatableService from "../../../Services/DatatableService";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        Head,
        Checkbox,
        Button,
        InputText,
        Image,
        Password,
        Message,
        Toolbar,
        Toast,
        FileUpload,
        DataTable,
        Column,
        InputNumber,
        Dropdown,
        RadioButton,
        Dialog,
        Calendar,
        AutoComplete,
    },
    data() {
        return {
            searchFilter: "",
            filters: {
                global: {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS,
                },
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
            },
            lazyParams: {
                global: {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS,
                },
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
            },
            loading: true,
            totalRecords: 0,
            selectedModel: null,
            model: {},
            modelDialog: false,
            models: null,
            selectedModels: null,
            submitted: false,
            selectAll: false,
            modelDetail: false,
            startDate: null,
            endDate: null,
            selectedEmployee: null,
            selectedUnit: null,
            autoFilteredValue: {
                employee: [],
                unit: []
            },
            userDetail: JSON.parse(sessionStorage.getItem('auth:me')) ?? [],
            exportLoading: {
                pdf: {
                    withPhoto: false,
                    withoutPhoto: false
                },
                excel: {
                    withPhoto: false,
                    withoutPhoto: false
                }
            }
        };
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
        this.initFilters();
    },
    mounted() {
        this.loading = true;
        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };
        this.loadLazyData();
    },
    methods: {
        searchEmployee(event) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    axios
                        .get(`${this.$page.props.appUrl}api/employees`)
                        .then((data) => {
                            this.autoFilteredValue = {
                                ... this.autoFilteredValue,
                                employee: data.data.data
                            };
                        });
                } else {
                    let filterValue = event.query.toLowerCase();
                    axios
                        .get(
                            `${this.$page.props.appUrl}api/employees?search=${filterValue}`
                        )
                        .then((data) => {
                            this.autoFilteredValue = {
                                ... this.autoFilteredValue,
                                employee: data.data.data
                            };
                        });
                }
            }, 250);
        },
        searchUnit(event){
            setTimeout(() => {
                if(!event.query.trim().length) {
                    axios
                        .get(`${this.$page.props.appUrl}api/placement-units?limit=10`)
                        .then((data) => {
                            this.autoFilteredValue = {
                                ... this.autoFilteredValue,
                                unit: data.data
                            };
                        })
                    return;
                }

                let filterValue = event.query.toLowerCase();
                axios
                    .get(
                        `${this.$page.props.appUrl}api/placement-units?search=${filterValue}&limit=10`
                    )
                    .then((data) => {
                        this.autoFilteredValue = {
                            ... this.autoFilteredValue,
                            unit: data.data
                        };
                    });
            }, 250)
        },
        loadLazyData() {
            this.loading = true;
            this.lazyParams.filters = this.filters;
            this.datatableService
                .getData(`${this.$page.props.appUrl}api/employee-attendances/datatable`, this.lazyParams)
                .then((data) => {
                    this.models = data.data;
                    this.totalRecords = data.total;
                    this.loading = false;
                });
        },
        onSelectAllChange(event) {
            const selectAll = event.checked;
            if (selectAll) {
                this.datatableService.getData(this.route("banks.index"),this.lazyParams).then((data) => {
                    this.selectAll = true;
                    this.selectedModels = data.data;
                });
            } else {
                this.selectAll = false;
                this.selectedModels = [];
            }
        },
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        onPage(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onFilter(event) {
            this.loadLazyData();
        },
        hideDialog() {
            this.modelDialog = false;
            this.submitted = false;
        },
        saveModel() {
            this.submitted = true;
            if (this.model) {
                if (this.model.id) {
                    axios
                        .put("api/banks/" + this.model.id, this.model)
                        .then((response) => {
                            this.$toast.add({
                                severity: "success",
                                summary: "Successful",
                                detail: "Bank Updated",
                                life: 3000,
                            });
                            this.loadLazyData();
                        })
                        .catch((error) => {
                            this.$toast.add({
                                severity: "error",
                                summary: "Error",
                                detail: "Bank not updated",
                                life: 3000,
                            });
                        });
                }
                // If empty then add new record
                else {
                    axios
                        .post("api/banks", this.model)
                        .then((response) => {
                            this.model = response.data.data;
                            this.models.unshift(this.model);
                            this.$toast.add({
                                severity: "success",
                                summary: "Successful",
                                detail: "Bank Created",
                                life: 3000,
                            });
                        })
                        .catch((error) => {
                            this.$toast.add({
                                severity: "error",
                                summary: "Error",
                                detail: "Bank not created",
                                life: 3000,
                            });
                        });
                }
                this.modelDialog = false;
                this.model = {};
            }
        },
        showDetail(model) {
            this.model = { ...model };

            axios.get(`${this.$page.props.appUrl}api/employee-attendances/${this.model.id}`)
            .then((data) => {
                this.modelDetail = data.data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: error,
                    life: 3000,
                });
            })

            this.modelDialog = true;
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS, field: 'id' },
            };
        },
        changeFilters(){
            this.filters = {
                global: {value: this.selectedEmployee ? this.selectedEmployee.id : null, field: 'id'},
                date: {fromDate: this.startDate, toDate: this.endDate},
                placement: this.selectedUnit ? this.selectedUnit.id : null,
            };
            this.loadLazyData();
        },
        exportExcel() {
            this.isExporting = true;
            this.exportLoading.excel.withPhoto = true;
            axios({
                method: 'get',
                url: this.$page.props.appUrl + 'api/employee-attendances/exports-excel',
                responseType: 'blob',
                params: this.lazyParams,
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Employee-Attendance.xlsx');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.exportLoading.excel.withPhoto = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.exportLoading.excel.withPhoto  = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        exportWithoutPhotoExcel() {
            this.isExporting = true;
            this.exportLoading.excel.withoutPhoto = true;
            axios({
                method: 'get',
                url: this.$page.props.appUrl + 'api/employee-attendances/exports-without-photo-excel',
                responseType: 'blob',
                params: this.lazyParams,
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Employee-Attendance-Without-Photo.xlsx');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.exportLoading.excel.withoutPhoto = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.exportLoading.excel.withoutPhoto = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        exportDetailToPdf(){
            this.isExporting = true;
            this.exportLoading.pdf.withPhoto = true;

            axios({
                method: 'get',
                url: this.$page.props.appUrl + `api/employee-attendances/exports`,
                responseType: 'blob',
                params: this.lazyParams,
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Employee-Attendances.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.exportLoading.pdf.withPhoto = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.exportLoading.pdf.withPhoto = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        exportWithoutPhotoToPdf(){
            this.isExporting = true;
            this.exportLoading.pdf.withoutPhoto = true;

            axios({
                method: 'get',
                url: this.$page.props.appUrl + `api/employee-attendances/exports-without-photo`,
                responseType: 'blob',
                params: this.lazyParams,
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Employee-Attendances.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.exportLoading.pdf.withoutPhoto = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.exportLoading.pdf.withoutPhoto = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../../../assets/demo/badges.scss";
</style>
